import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseCreatePrivateCompanyLeadGenericDocumentProps {
  privateCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useCreatePrivateCompanyLeadGenericDocument = ({ privateCompanyLeadId, onSuccess, onError }: UseCreatePrivateCompanyLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadGenericDocument'],
    mutationFn: (data: { blob_id: string }) => {
      const private_company_lead = {
        generic_documents_attachments_attributes: [
          {
            blob_id: data.blob_id,
          }
        ]
      }

      return privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}
